<script lang="ts">
  import { Col, Row } from "sveltestrap";
  import UserAccordion from "./UserAccordion.svelte";
  import UserFollowers from "./UserFollowers.svelte";
  import UserPhotos from "./UserPhotos.svelte";
  import UserFriends from "./UserFriends.svelte";
</script>

<Col xl="3" lg="12" md="5" class="xl-35">
  <div class="default-according style-1 faq-accordion job-accordion">
    <Row>
      <UserAccordion />
      <UserFollowers />
      <UserPhotos />
      <UserFriends />
    </Row>
  </div>
</Col>
